import { React, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CancelIcon from "@mui/icons-material/Cancel";
import Image from "../../../images/otpModal.png";
import { InputAdornment, TextField } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import VerifiedModal from "./verifiedModal";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { Navigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 525,
  minWidth: 303,
  bgcolor: "#FFFFFF",
  borderRadius: "24px",
  boxShadow: 24,
  p: "1rem 1.4rem ",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

export default function OtpModal(props) {
  const [otp, setOtp] = useState("");
  // Modal use State
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const navigate = useNavigate();
  // Function
  const handleSubmit2 = (e) => {
    e.preventDefault();
    console.log(otp);
    axios
      .post("https://api.blockpay.co.za/merchant/verify", {
        email: localStorage.getItem("email"),
        otp: otp,
      })
      .then((res) => {
        toast.success(res.data.message);
        console.log(res.data);
        handleOpen();
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.response.data.message);
        if (err.response.data.message === "User already exists") {
          navigate("/signinpin", { replace: true });
        }
      });
  };
  const sendOtp = (e) => {
    e.preventDefault();
    axios
      .post("https://api.blockpay.co.za/merchant/sendOtp", {
        email: localStorage.getItem("email"),
      })
      .then((res) => {
        toast.success(res.data.message);
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.response.data.message);
        if (err.response.data.message === "User already exists") {
          navigate("/signipin", { replace: true });
        }
      });
  };
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        {...props}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={props.open}>
          <Box sx={style}>
            <Box
              sx={{
                color: "#919191",
                marginLeft: "auto",
              }}
              onClick={props.onClose}
            >
              <CancelIcon />
            </Box>
            <Box
              component="img"
              src={Image}
              sx={{ height: "200px", width: "230px" }}
            />
            <Typography
              id="transition-modal-title"
              variant="h5"
              component="h2"
              sx={{ fontWeight: "500", lineHeight: "2.421rem" }}
            >
              Enter OTP
            </Typography>
            <Typography
              id="transition-modal-description"
              sx={{
                mt: 1,
                fontSize: "16px!important",
                color: "#626262",
                textAlign: "center",
              }}
            >
              We have sent a verification code on your email ID{" "}
              <strong>{props.email}</strong>. Please enter verification code
              below.
            </Typography>
            <TextField
              sx={{
                maxWidth: "453px",
                borderRadius: "12px",
                width: "100%",
                mt: 3,
              }}
              label="Email Verification Code"
              InputLabelProps={{
                shrink: true,
              }}
              // InputProps={{
              //   endAdornment: (
              //     <InputAdornment position="end">
              //       <Box sx={{ display: "flex", alignItems: "center" }}>
              //         <Typography
              //           sx={{
              //             fontWeight: "500",
              //             color: "#0582FF",
              //           }}
              //           onClick={sendOtp}
              //         >
              //           Resend Code
              //         </Typography>
              //       </Box>
              //     </InputAdornment>
              //   ),
              // }}
              variant="outlined"
              type="password"
              onChange={(e) => setOtp(e.target.value)}
              required
            />
            <Typography sx={{ mt: 5, display: "flex" }}>
              Didn't receive a code?&nbsp;{" "}
              <Box
                sx={{
                  textDecoration: "none",
                  color: "#666666",
                  fontWeight: "500",
                }}
                onClick={sendOtp}
              >
                <Link className="underline">Resend</Link>
              </Box>
            </Typography>
            <Button
              className="loginButtonSignUp"
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              onClick={handleSubmit2}
              sx={{ textTransform: "none", borderRadius: "10px", mb: "1rem" }}
            >
              <span className="buttonSignText">Submit</span>
            </Button>
            <VerifiedModal open={open} onClose={handleClose} />
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
